// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"775":"gsap","9508":"ScrollTrigger"}[chunkId] + "." + {"775":"77dc441b956be33dded5","9508":"6beeabc78ab591c58a42"}[chunkId] + ".js";
};